module.exports = __webpack_public_path__ + "static/assets/ee1ff98a40085422a1e8426271dc185d.png";